/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'ai-mate.agent-list.delete-agent-confirm-body':
    'Voulez-vous vraiment supprimer cet agent ? Cette action est irréversible.',
  'ai-mate.agent-list.delete-agent-confirm-title': 'Supprimer « {agentName} » ?',
  'ai-mate.agent-list.delete-agent-error': "Impossible de supprimer l'agent",
  'ai-mate.agent-list.delete-agent-error.agent-in-use': "L'agent est en cours d'utilisation. Réessayez ultérieurement.",
  'ai-mate.agent-list.delete-agent-error.agent-not-found': 'Cet agent est introuvable.',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    "Vous ne pouvez pas supprimer des agents que vous n'avez pas vous-même créés. Veuillez contacter le propriétaire de l'agent.",
  'ai-mate.agent-list.delete-agent-success': "L'agent a été supprimé !",
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': 'Annuler',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': 'Supprimer',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': 'Agent · {description}',
  'ai-mate.agent-selector.default-agent-description':
    'Obtenez des réponses, générez de nouvelles idées et accélérez le travail quotidien. Rédigez une invite pour vous lancer.',
  'ai-mate.agent-selector.default-agent-name': 'Chat',
  'conversation-assistant-agent.create-agent.agent-name-copy': '{agentName} - Copie',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label':
    'Faites glisser pour réorganiser',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error':
    "Impossible d'enregistrer les changements",
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error':
    'Une erreur inconnue est survenue. Veuillez réessayer',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error':
    'Un agent portant ce nom existe déjà',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': 'Supprimer',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text':
    'Générer des prompts pour engager la conversation',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    '{maxLength, plural, one {{fieldName} ne peut pas dépasser {maxLength,number} caractère} other {{fieldName} ne peut pas dépasser {maxLength,number} caractères}}',
  'conversation-assistant-agent.create-agent.restart-creation-button-label': 'Relancer la création',
  'conversation-assistant-agent.create-agent.skip-to-configure-button-label': 'Passer à la configuration manuelle',
  'rovo-chat.browse-agents.all-agents-button': 'Tous',
  'rovo-chat.browse-agents.close-button': 'Fermer',
  'rovo-chat.browse-agents.create-agent-button': 'Créer',
  'rovo-chat.browse-agents.create-an-agent-button': 'Créer un agent',
  'rovo-chat.browse-agents.created-by-label': '<text>par</text> {creatorName}',
  'rovo-chat.browse-agents.favourited-agent-label': 'Agent ajouté aux favoris',
  'rovo-chat.browse-agents.learn-more': 'En savoir plus',
  'rovo-chat.browse-agents.modal-title': 'Parcourir les agents',
  'rovo-chat.browse-agents.more-actions-label': "Plus d'actions",
  'rovo-chat.browse-agents.my-agents-button': 'Mes agents',
  'rovo-chat.browse-agents.no-created-agents':
    "Il semblerait que vous n'ayez encore créé d'agent. Commencez par dupliquer d'autres agents existants ou créez-en un à partir de zéro.",
  'rovo-chat.browse-agents.no-created-agents-header': "Aucun agent créé pour l'instant",
  'rovo-chat.browse-agents.no-results': 'Aucun résultat',
  'rovo-chat.browse-agents.search-input.placeholder': 'Rechercher des agents',
  'rovo-chat.browse-agents.starred-agents-button': 'Mis en favori',
  'rovo-chat.create-agent.all-content-label': 'Tout le contenu',
  'rovo-chat.create-agent.all-spaces-label': 'Tous les espaces',
  'rovo-chat.create-agent.back-button': 'Retour',
  'rovo-chat.create-agent.confirm-leave-modal.body':
    "Vous n'avez pas encore créé votre agent, souhaitez-vous le supprimer ?",
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': 'Annuler',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': "Oui, supprimer l'agent",
  'rovo-chat.create-agent.confirm-leave-modal.title': 'Agent non terminé',
  'rovo-chat.create-agent.confirm-restart-modal.body':
    'Voulez-vous vraiment supprimer toutes les informations existantes et relancer la création de votre agent ?',
  'rovo-chat.create-agent.confirm-restart-modal.title': 'Relancer la création',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    "Les gens peuvent les utiliser pour lancer une conversation avec votre agent. Si rien ne vous vient à l'esprit, nous pouvons les générer pour vous.",
  'rovo-chat.create-agent.conversation-starters-field-label': 'Prompts pour engager la conversation',
  'rovo-chat.create-agent.create-agent-button': 'Créer',
  'rovo-chat.create-agent.description-field-description':
    "Les gens peuvent utiliser la description sur le profil de l'agent pour en savoir plus à son sujet.",
  'rovo-chat.create-agent.description-field-label': 'Description',
  'rovo-chat.create-agent.description-field-placeholder':
    'Rédigez une brève description de votre agent (par exemple, rédacteur créatif pour les billets de blog marketing)',
  'rovo-chat.create-agent.instructions-field-description':
    "Comment voulez-vous que cet agent se comporte ? Que peut-il faire ? <link>En savoir plus sur la rédaction d'instructions pour un agent</link>",
  'rovo-chat.create-agent.instructions-field-label': 'Instructions',
  'rovo-chat.create-agent.instructions-field-placeholder': 'Personnalisez les instructions pour cet agent',
  'rovo-chat.create-agent.knowledge-field-description':
    "Spécifiez les connaissances de l'agent en l'autorisant uniquement à faire référence aux sources que vous fournissez",
  'rovo-chat.create-agent.knowledge-field-label': 'Connaissances',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': 'Uniquement faire référence à ces sources',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': 'Suggérés',
  'rovo-chat.create-agent.name-field-description': "Les gens peuvent utiliser ceci pour rechercher l'agent.",
  'rovo-chat.create-agent.name-field-label': 'Nom',
  'rovo-chat.create-agent.name-field-placeholder': 'Donnez un nom à votre agent',
  'rovo-chat.create-agent.nl-input-field.placeholder': 'Saisissez votre message',
  'rovo-chat.create-agent.nl-input-field.send-button-label': 'Envoyer',
  'rovo-chat.create-agent.page-title': 'Créer un agent',
  'rovo-chat.create-agent.page-title-edit': 'Modifier un agent',
  'rovo-chat.create-agent.publish-option.hide-agent-description': "N'apparaîtra pas dans les résultats de recherche.",
  'rovo-chat.create-agent.publish-option.hide-agent-label': "Masquer l'agent",
  'rovo-chat.create-agent.publish-option.show-agent-description': 'Disponible pour tout le monde sur ce site.',
  'rovo-chat.create-agent.publish-option.show-agent-label': "Afficher l'agent",
  'rovo-chat.create-agent.update-agent-button': 'Mettre à jour',
  'rovo-chat.view-agent.about-label': 'À propos',
  'rovo-chat.view-agent.chat-to-agent-button': 'Chat avec un agent',
  'rovo-chat.view-agent.close-button': 'Fermer',
  'rovo-chat.view-agent.copy-instructions-label': 'Copier',
  'rovo-chat.view-agent.copy-instructions-tooltip': 'Copier la réponse',
  'rovo-chat.view-agent.copy-link-to-profile': 'Copier le lien',
  'rovo-chat.view-agent.created-by-label': '<text>par</text> {agentName}',
  'rovo-chat.view-agent.delete-agent': "Supprimer l'agent",
  'rovo-chat.view-agent.duplicate-agent': "Dupliquer l'agent",
  'rovo-chat.view-agent.edit-agent': "Modifier l'agent",
  'rovo-chat.view-agent.favourites-metadata-label': 'Nombre de favoris',
  'rovo-chat.view-agent.go-back-label': 'Retour',
  'rovo-chat.view-agent.instructions-label': 'Instructions',
  'rovo-chat.view-agent.knowledge-label': 'Connaissances',
  'rovo-chat.view-agent.link-copied-to-profile': 'URL copiée',
  'rovo-chat.view-agent.modal-title': 'Rechercher des agents',
  'rovo-chat.view-agent.more-actions-label': "Plus d'actions",
  'rovo-chat.view-agent.no-instruction-placeholder': "Cet agent n'a pas d'instructions personnalisées",
  'rovo-chat.view-agent.no-knowledge-added': 'Aucune source de connaissances partagée',
  'rovo-chat.view-agent.open-chat-label': 'Ouvrir le chat',
  'rovo-chat.view-agent.reactions-metadata-label': 'Nombre de réactions',
  'rovo-chat.view-agent.rovo-agent-label': 'Agent Rovo',
  'rovo-chat.view-agent.users-metadata-label': "Nombre d'utilisateurs",
  'rovo-chat.view-agents.view-agent': "Voir l'agent",
};
